import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getClarityIdAPI } from '../services/clarityAPI';

interface ClarityState {
  clarityId: string;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ClarityState = {
  clarityId: '',
  status: 'idle',
  error: null,
};

export const fetchClarityId = createAsyncThunk<
  string,
  string,
  { rejectValue: string }
>(
  'clarity/fetchClarityId',
  async (tenantName: string, { rejectWithValue }) => {
    try {
      const clarityId = await getClarityIdAPI(tenantName);
      return clarityId;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch Clarity ID');
    }
  }
);

const claritySlice = createSlice({
  name: 'clarity',
  initialState,
  reducers: {
    clearClarity(state) {
      state.clarityId = '';
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClarityId.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(
        fetchClarityId.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.status = 'succeeded';
          state.clarityId = action.payload;
        }
      )
      .addCase(fetchClarityId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const { clearClarity } = claritySlice.actions;
export default claritySlice.reducer;
